<template>
  <div>
    <!-- 整合后的卡片：包含订阅设置和订阅列表 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <el-form inline>
            <el-form-item
              label="订阅者名称"
              label-width="90px"
              style="margin-right: 20px; margin-bottom: 0;"
              class="custom-label"
            >
              <el-select
                v-model="searchData.name"
                @change="search"
                filterable
                clearable
                placeholder="请选择订阅者"
                style="width:200px;"
              >
                <el-option value="" label="全部"></el-option>
                <el-option
                  v-for="name in subscriberNames"
                  :key="name"
                  :label="name"
                  :value="name"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="margin-bottom:0;">
              <el-button @click="refreshAll" type="primary">刷新所有列表</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 第一部分：是否订阅Dis业务数据 -->
      <el-divider content-position="center" class="custom-divider">
        <span class="divider-content">订阅者列表</span>
      </el-divider>

      <!-- 订阅者列表 -->
      <List
        url="subscriber/subscriber/"
        class="subscriber-table"
        :title="subscriberTitle"
        :data="searchData"
        :tanle="subscriberTable"
        :afterList="dealSubscriberList"
        :update="subscriberUpdateList"
        :operat="subscriberOperation"
        :MultipleSel="true"
        :useBatchSuffix="false"
        :showPagination="false"
        @edit="editSubscriber"
        @deletedata="deleteSubscriber"
        @batchPost="handleBatchDeleteSubscriberPost"
      >
        <div slot="Fresh" style="float:right;">
          <span style="margin-right:5px;font-size:13px;">是否订阅订Dis：</span>
          <el-select
            v-model="selectBusinessDisStatus"
            placeholder="选择Dis订阅状态"
            @change="search"
            size="small"
            style="width:100px;margin-right:10px;"
          >
            <el-option value="全部" label="全部"></el-option>
            <el-option
              v-for="dis_business_subscription in businessDisStatus"
              :label="dis_business_subscription"
              :key="dis_business_subscription"
              :value="dis_business_subscription"
            ></el-option>
          </el-select>

          <span style="margin-right:5px;font-size:13px;">邮件通知模板：</span>
          <el-select
            v-model="selectEmailTemplateType"
            placeholder="选择邮件通知模板"
            @change="search"
            size="small"
            style="width:100px;margin-right:10px;"
          >
            <el-option value="全部" label="全部"></el-option>
            <el-option
              v-for="email_template in emailTemplateTypes"
              :label="email_template.name"
              :key="email_template.value"
              :value="email_template.value"
            ></el-option>
          </el-select>

          <el-checkbox
            v-model="email_verified_at"
            @change="search"
            style="margin-right:10px;"
            size="small">
            仅显示未验证邮箱
          </el-checkbox>

          <el-button
            @click="addSubscriber"
            type="primary"
            size="small"
            icon="el-icon-edit"
            >新增订阅者</el-button>

          <el-button @click="subscriberUpdateList++" type="primary" size="small"
            >刷新列表</el-button>
        </div>

        <template v-slot:slot-dis_business_subscription_display="scope">
          <el-switch
            v-model="scope.item.dis_business_subscription"
            :active-value="1"
            :inactive-value="0"
            active-color="#67C23A"
            @change="updateSubscription(scope.item)"
          ></el-switch>
        </template>

        <template v-slot:slot-template_type="scope">
          <el-tag :type="scope.item.template_type === 1 ? 'success' : 'danger'">
            {{ getTemplateTypeName(scope.item.template_type) }}
          </el-tag>
        </template>

        <template v-slot:slot-email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.email  }}
          </div>
        </template>

        <template v-slot:slot-cc_email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.cc_email  }}
          </div>
        </template>

        <template v-slot:slot-bc_email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.bc_email  }}
          </div>
        </template>

        <template v-slot:slot-email_verified_at="scope">
          <template v-if="scope.item.email_verified_at === '待验证'">
            <el-tag
              type="danger"
              effect="plain"
              style="background-color: rgba(245, 108, 108, 0.1)"
            >
              {{ scope.item.email_verified_at }}
            </el-tag>
          </template>
          <template v-else>
            {{ scope.item.email_verified_at }}
          </template>
        </template>
      </List>

      <!-- 第二部分：Dis业务数据订阅列表 -->
      <el-divider content-position="center" class="custom-divider">
        <span class="divider-content">订阅详情</span>
      </el-divider>

      <!-- Dis订阅列表 -->
      <List
        url="subscriber/sre-api/businesss_report_dis/"
        class="dis-subscription-table"
        :title="disSubscriptionTitle"
        :data="searchData"
        :tanle="disSubscriptionTable"
        :afterList="dealDisSubscriptionList"
        :operat="disSubscriptionOperation"
        :update="disSubscriptionUpdateList"
        :MultipleSel="true"
        :useBatchSuffix="false"
        @edit="editDisSubscription"
        @deletedata="deleteDisSubscription"
      >
        <div slot="Fresh" style="float:right;">
          <el-select
            multiple
            v-model="selectClouds"
            @change="search"
            placeholder="请选择云平台（多选）"
            style="width:200px;margin-right:10px;"
            size="small"
          >
            <el-option
              v-for="cloud in cloudEnvList"
              :label="cloud"
              :key="cloud"
              :value="cloud"
            ></el-option>
          </el-select>

          <el-input
            v-model="searchData.dis"
            @change="search"
            size="small"
            style="width:160px;margin-right:10px;"
            placeholder="请输入Dis账号"
          ></el-input>

          <el-button
            @click="addDisSubscription"
            type="primary"
            size="small"
            icon="el-icon-edit"
            >新增Dis订阅</el-button
          >

          <el-button
            @click="disSubscriptionUpdateList++"
            type="primary"
            size="small"
            >刷新列表</el-button
          >
        </div>

        <template v-slot:slot-subscriber_email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.subscriber_email  }}
          </div>
        </template>

        <template v-slot:slot-subscriber_cc_email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.subscriber_cc_email  }}
          </div>
        </template>

        <template v-slot:slot-subscriber_bc_email="scope">
          <div class="cell-wrap-content">
            {{ scope.item.subscriber_bc_email  }}
          </div>
        </template>

        <template v-slot:slot-dis="scope">
          <div class="cell-wrap-content">
            {{ scope.item.dis }}
          </div>
        </template>
      </List>
    </el-card>

      <!-- 订阅者更新框 -->
      <SubscriberUpdateBox
        :initForm="updateForm"
        :updateType="updateType"
        :clouds="cloudEnvList"
        v-if="updateBlock && formType === 'subscriber'"
        @close="close"
        @update="subscriberUpdateList++"
      ></SubscriberUpdateBox>

      <!-- Dis订阅更新框 -->
      <SubscriberBusinessReportDisUpdateBox
        :initForm="updateForm"
        :updateType="updateType"
        :clouds="cloudEnvList"
        :subscriberNames="subscriberNames"
        v-if="updateBlock && formType === 'disSubscription'"
        @close="close"
        @update="disSubscriptionUpdateList++"
      ></SubscriberBusinessReportDisUpdateBox>
  </div>
</template>

<script>
import { HasStatus, SubscriberEmailTemplateTypes } from "../components/Index/data.js";

import List from "../components/common/List.vue";
import SubscriberUpdateBox from "../components/Subscriber/SubscriberUpdateBox.vue";
import SubscriberBusinessReportDisUpdateBox from "../components/Subscriber/SubscriberBusinessReportDisUpdateBox.vue";

export default {
  components: {
    List,
    SubscriberUpdateBox,
    SubscriberBusinessReportDisUpdateBox
  },
  data() {
    return {
      // 订阅者相关
      subscriberTitle: "订阅者",
      subscriberTable: [
        { name: "name", label: "订阅人" },
        { name: "email", label: "收件邮箱" },
        { name: "cc_email", label: "抄送邮箱" },
        { name: "bc_email", label: "密件抄送邮箱" },
        // { name: "email_verified_at", label: "邮箱验证时间" },
        { name: "dis_business_subscription_display", label: "是否订阅Dis业务数据" },
        { name: "template_type", label: "邮件通知模板类型" },
        { name: "remark", label: "备注" },
        { name: "updated", label: "修改时间" }
      ],
      subscriberOperation: [
        { text: "Edit", eventName: "edit" },
        { text: "Deletedata", eventName: "deletedata" }
      ],
      subscriberUpdateList: 0,

      // Dis订阅相关
      disSubscriptionTitle: "Dis业务数据订阅",
      disSubscriptionTable: [
        { name: "subscriber_name", label: "订阅人" },
        { name: "subscriber_email", label: "收件邮箱" },
        { name: "subscriber_cc_email", label: "抄送邮箱" },
        { name: "subscriber_bc_email", label: "密件抄送邮箱" },
        { name: "cloud", label: "云平台" },
        { name: "dis", label: "Dis账号" },
        { name: "remark", label: "备注" },
      ],
      disSubscriptionOperation: [
        { text: "Edit", eventName: "edit" },
        { text: "Deletedata", eventName: "deletedata" }
      ],
      disSubscriptionUpdateList: 0,

      // 其他数据保持不变
      subscribeForm: {
        dis_business_subscription: "是",  // 改为字符串
        name: ""
      },
      selectClouds: [],
      cloudEnvList: [],
      selectBusinessDisStatus: "全部",
      businessDisStatus: HasStatus,
      selectEmailTemplateType: "全部",
      emailTemplateTypes: SubscriberEmailTemplateTypes,
      subscriberNames: [],
      searchData: {
        name: "",
        subscriber_name: "",
        template_type: "",
        cloud: "",
        dis: "",
        dis_business_subscription: "",
      },
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      formType: "", // 添加一个字段来区分当前打开的是哪个表单
      token: localStorage.getItem("token") // 添加 token 变量
    };
  },
  mounted() {
    this.fetchSubscriberNames();
    this.fetchCloudEnvs();
  },
  methods: {
    refreshAll() {
      this.subscriberUpdateList++;
      this.disSubscriptionUpdateList++;
      this.fetchSubscriberNames();
    },
    initData() {
      this.subscribeForm.name = "";
      this.searchData.subscriber_name = "";
      this.fetchCloudEnvs();
      this.fetchSubscriberInfo();
    },
    fetchSubscriberInfo() {
      const name = this.subscribeForm.name;
      if (name) {
        this.$http["get"](`subscriber/subscriber/?name=${name}`, {}, data => {
          if (data.data.results && data.data.results.length > 0) {
            this.subscribeForm.dis_business_subscription = data.data.results[0].dis_business_subscription ? "是" : "否";
            this.subscribeForm.id = data.data.results[0].id;
          }
        });
      }
    },
    updateSubscription(item) {
      const params = {
        name: item.name,
        dis_business_subscription: typeof item.dis_business_subscription === 'string'
          ? (item.dis_business_subscription === "是" ? 1 : 0)
          : item.dis_business_subscription
      };

      const url = `subscriber/subscriber/${item.id}/`;

      this.$http["patch"](
        url,
        params,
        () => {
          this.$baseNotice.message("订阅状态更新成功");
          this.subscriberUpdateList++;
        },
        () => {
          this.$message({
            message: "订阅状态更新失败",
            type: "error"
          });
          // 恢复原值，避免UI显示与实际状态不一致
          item.dis_business_subscription = !item.dis_business_subscription;
        }
      );
    },
    search() {
      if (this.searchData.name !== undefined) {
        this.searchData.subscriber_name = this.searchData.name;
      }

      if (this.selectBusinessDisStatus === "全部") {
        this.searchData.dis_business_subscription = "";
      } else {
        this.searchData.dis_business_subscription = +(
          this.selectBusinessDisStatus === "是"
        );
      }

      if (this.selectEmailTemplateType === "全部") {
        this.searchData.template_type = "";
      } else {
        this.searchData.template_type = this.selectEmailTemplateType;
      }

      if (this.selectClouds && this.selectClouds.length > 0) {
        this.searchData.cloud = this.selectClouds.join(",");
      } else {
        this.searchData.cloud = "";
      }

      this.subscriberUpdateList++;
      this.disSubscriptionUpdateList++;
    },
    fetchSubscriberNames() {
      this.$http["get"]("subscriber/subscriber/", {}, data => {
        if (data && data.data && data.data.results) {
          this.subscriberNames = data.data.results.map(item => item.name);
        }
      });
    },
    dealSubscriberList(data) {
      if (this.email_verified_at && Array.isArray(data)) {
        data = data.filter(item => !item.email_verified_at);
      }

      for (let i in data) {
        data[i].updated = this.changeDate(data[i].updated);
        data[i].email_verified_at = data[i].email_verified_at
          ? this.changeDate(data[i].email_verified_at)
          : "待验证";
        data[i].dis_business_subscription_display = data[i]
          .dis_business_subscription
          ? "是"
          : "否";
      }
      return data;
    },
    getTemplateTypeName(value) {
      const template = this.emailTemplateTypes.find(t => t.value === value);
      return template ? template.name : '未知类型';
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString();
      var nowMin = time.getMinutes().toString();
      var nowSeconds = time.getSeconds().toString();

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"]("cloud/env/", {}, data => {
        this.cloudEnvList = data.data.results.map(item => item.cloud);
      });
    },
    addSubscriber() {
      this.updateForm = {
        name: "",
        dis_business_subscription: "是",
        template_type: this.emailTemplateTypes[1].name,
      };
      this.updateType = "add";
      this.updateBlock = true;
      this.formType = "subscriber"; // 设置表单类型为订阅者
    },
    addDisSubscription() {
      this.updateForm = {
        subscriber_name: this.searchData.name || "",
        cloud: "",
        dis: ""
      };
      this.updateType = "add";
      this.updateBlock = true;
      this.formType = "disSubscription"; // 设置表单类型为 Dis 订阅
    },
    close() {
      this.updateBlock = false;
      this.updateForm = {};
      this.formType = ""; // 清空表单类型
      this.fetchSubscriberNames();
    },
    deleteSubscriber(val) {
      this.$confirm("确认删除该订阅者吗? 删除后将无法恢复", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let url = `subscriber/subscriber/${val.id}/`;
        this.$http["delete"](
          url,
          () => {
            this.$baseNotice.message("删除成功");
            this.fetchSubscriberNames();
            this.subscriberUpdateList++;
            this.disSubscriptionUpdateList++;
          },
          () => {
            this.$message({
              message: "删除失败",
              type: "error"
            });
          }
        );
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    handleBatchDeleteSubscriberPost() {
      this.fetchSubscriberNames();
      this.subscriberUpdateList++;
      this.disSubscriptionUpdateList++;
    },
    dealDisSubscriptionList(data) {
      return data;
    },
    editDisSubscription(val) {
      this.updateForm = {
        remark: val.remark,
        subscriber_email: val.subscriber_email,
        cloud: val.cloud,
        dis: val.dis,
        id: val.id
      };
      this.updateType = "edit";
      this.updateBlock = true;
      this.formType = "disSubscription";
    },
    editSubscriber(val) {
      const formData = Object.assign({}, val);
      this.updateForm = formData;
      this.updateType = "edit";
      this.updateBlock = true;
      this.formType = "subscriber";
    },
    deleteDisSubscription(val) {
      this.$confirm("确认删除该Dis业务数据订阅吗? 删除后将无法恢复", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let url = `subscriber/sre-api/businesss_report_dis/${val.id}/`;
        this.$http["delete"](
          url,
          () => {
            this.$baseNotice.message("删除成功");
            this.disSubscriptionUpdateList++;
          },
          () => {
            this.$message({
              message: "删除失败",
              type: "error"
            });
          }
        );
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
  border-radius: 6px;
  overflow: hidden;
}

.custom-divider {
  margin-top: 60px;

  .divider-content {
    font-size: 16px;
    font-weight: 500;
    color: #409eff;
    background-color: #fff;
    padding: 0 15px;
    position: relative;

    &::before,
    &::after {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #409eff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }
}

.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

/deep/ .custom-label {
  .el-form-item__label {
    font-weight: bold !important;
    color: #333 !important;
    font-size: 14px;
    padding-right: 12px;

    &::after {
      content: "";
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #409eff;
    }
  }

  &:hover .el-form-item__label {
    color: #66b1ff !important;

    &::after {
      background-color: #66b1ff;
    }
  }
}

/* dis 字段样式 */
.cell-wrap-content {
  white-space: pre-line;  // 换行后内容对齐
  word-break: break-word;
  max-width: 300px;
  padding: 8px 0;
  display: block;
  margin: 0;
}

/* 订阅者列表内容左对齐 */
/deep/ .subscriber-table .el-table__row {
  td:nth-child(2) .cell,
  td:nth-child(3) .cell,
  td:nth-child(4) .cell,
  td:nth-child(5) .cell,
  td:nth-child(8) .cell {
    text-align: left !important;
  }
}

/* Dis订阅列表内容左对齐 */
/deep/ .dis-subscription-table .el-table__row {
  td:nth-child(2) .cell,
  td:nth-child(3) .cell,
  td:nth-child(4) .cell,
  td:nth-child(5) .cell,
  td:nth-child(6) .cell {
    text-align: left !important;
  }
}

</style>
